import { ExpandAltOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { Tabs } from "../Tabs";
import { useRecoilState } from "recoil";
import { golfExpandCriticalImages } from "store/atom";
import { Tooltip } from "antd";
import { LayoutIcon } from "icons";

const tabsArr = [
  {
    title: "Face On",
    key: "faceon",
  },
  {
    title: "Down The Line",
    key: "downtheline",
  },
];
export const ImagesActionHeader = ({
  isDesktop,
  setImagesCarousel,
  setImageIndex,
  setExpandCriticalImages,
  expandCriticalImages,
  showLayoutChangeIcon,
}) => {
  //   const [expandCriticalImages, setExpandCriticalImages] = useRecoilState(golfExpandCriticalImages);

  return (
    <div className={styles.header}>
      <div
        style={{
          visibility: expandCriticalImages ? "hidden" : "visible",
        }}
        className={styles.expandWrapper}
      >
        <ExpandAltOutlined
          onClick={() => setExpandCriticalImages(true)}
          style={{ color: "#006AB3", fontSize: "20px" }}
        />
      </div>
      <div className={styles.tabAndLayout}>
        <ConditionalRenderer condition={isDesktop}>
          <div className={styles.switchTab}>
            <Tabs tabsArr={tabsArr} variant="faceonOrDTL" />
          </div>
        </ConditionalRenderer>
        <ConditionalRenderer condition={showLayoutChangeIcon}>
          <Tooltip title="Change Layout">
            <LayoutIcon
              height={17}
              width={17}
              onClick={() => {
                setImagesCarousel((prev) => !prev);
                setImageIndex(0);
              }}
            />
          </Tooltip>
        </ConditionalRenderer>
      </div>
    </div>
  );
};
